import React, { useMemo } from "react";
import { Trophy, X } from "lucide-react";
import { PackagerCard } from "./PackagerCard";

const computePackagerStats = (leads) => {
  const map = {};
  (leads || []).forEach((l) => {
    const p = l.packager;
    if (!p) return;
    if (!map[p]) map[p] = { name: p, count: 0, funded: 0 };
    map[p].count += 1;
    if (l.status === "Funded") map[p].funded += 1;
  });
  return Object.values(map).sort((a, b) => b.count - a.count);
};

export const TopPackagers = ({ leads, selected, onSelect }) => {
  const packagers = useMemo(() => computePackagerStats(leads), [leads]);

  if (!leads || packagers.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] p-6 mb-6" data-testid="top-packagers">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Trophy size={18} className="text-[#052F24]/40" />
          <h2 className="font-display font-bold text-sm tracking-wide uppercase text-[#052F24]/70">
            Top packagers
          </h2>
        </div>
        {selected && (
          <button
            onClick={() => onSelect("")}
            data-testid="clear-packager-filter-btn"
            className="flex items-center gap-1 text-xs font-semibold text-[#052F24]/60 hover:text-[#052F24] transition-colors"
          >
            <X size={12} /> Clear filter
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-3">
        {packagers.map((p, i) => (
          <PackagerCard key={p.name} packager={p} index={i} active={selected === p.name} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};
